import { Component, ElementRef, HostBinding, viewChild, ChangeDetectionStrategy } from '@angular/core';
import { IHeaderAngularComp } from 'ag-grid-angular';
import { IHeaderParams } from 'ag-grid-community';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';

@Component({
  selector: 'ml-mdm-devices-ag-grid-header',
  templateUrl: './mdm-devices-ag-grid-header.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [FaIconComponent],
})
export class MdmDevicesAgGridHeaderComponent implements IHeaderAngularComp {
  @HostBinding('class') class = 'h-100 w-100';

  private readonly serialNumberFilter = viewChild.required('serialNumberFilter', { read: ElementRef });
  private params!: IHeaderParams;

  agInit(params: IHeaderParams): void {
    this.params = params;
  }

  refresh(): boolean {
    return false;
  }

  onSerialNumberFilterClicked() {
    this.params.showColumnMenu(this.serialNumberFilter().nativeElement);
  }
}
